/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcAssetsV1MoneyMarketStatsState } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_ASSETS_V1_MONEY_MARKET_STATS_STATE_ENTITY_NAME = 'ixc.assets.v1.MoneyMarketStats';
export const ixcAssetsV1MoneyMarketStatsStateEntity = new schema.Entity<IxcAssetsV1MoneyMarketStatsState>(IXC_ASSETS_V1_MONEY_MARKET_STATS_STATE_ENTITY_NAME, {}, { idAttribute: (entity: IxcAssetsV1MoneyMarketStatsState) => `${entity.assetId}-${entity.date}` });

